var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "div",
        { staticClass: "search-term" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchInfo }
            },
            [
              _vm.userInfo.sellerId == 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "调出便利店" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "搜索条件"
                          },
                          model: {
                            value: _vm.searchInfo.outSellerId,
                            callback: function($$v) {
                              _vm.$set(_vm.searchInfo, "outSellerId", $$v)
                            },
                            expression: "searchInfo.outSellerId"
                          }
                        },
                        _vm._l(_vm.allStations, function(item) {
                          return _c("el-option", {
                            key: item.ID,
                            attrs: { label: item.stationName, value: item.ID }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "接收便利店" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "搜索条件"
                      },
                      model: {
                        value: _vm.searchInfo.inSellerId,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "inSellerId", $$v)
                        },
                        expression: "searchInfo.inSellerId"
                      }
                    },
                    _vm._l(_vm.sellerAllOptions, function(item) {
                      return _c("el-option", {
                        key: item.sellerId,
                        attrs: { label: item.sellerName, value: item.sellerId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm.userInfo.sellerId > 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "操作类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "搜索条件"
                          },
                          model: {
                            value: _vm.searchInfo.optType,
                            callback: function($$v) {
                              _vm.$set(_vm.searchInfo, "optType", $$v)
                            },
                            expression: "searchInfo.optType"
                          }
                        },
                        [
                          _c("el-option", {
                            key: 1,
                            attrs: { label: "调出", value: 1 }
                          }),
                          _c("el-option", {
                            key: 2,
                            attrs: { label: "调入", value: 2 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchInfo.allocationStatus,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "allocationStatus", $$v)
                        },
                        expression: "searchInfo.allocationStatus"
                      }
                    },
                    [
                      _c("el-option", {
                        key: "1",
                        attrs: { label: "未提交", value: "1" }
                      }),
                      _c("el-option", {
                        key: "2",
                        attrs: { label: "待接收", value: "2" }
                      }),
                      _c("el-option", {
                        key: "3",
                        attrs: { label: "已接收", value: "3" }
                      }),
                      _c("el-option", {
                        key: "4",
                        attrs: { label: "拒绝接收", value: "4" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("查询")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bairun-table-btns" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onAdd } },
            [_vm._v("新增调拨")]
          )
        ],
        1
      ),
      _c("el-pagination", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          height: "45rem",
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      }),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            height: "45rem",
            "tooltip-effect": "dark"
          },
          on: {
            "selection-change": _vm.handleSelChange,
            "row-dblclick": _vm.onRowdbclick
          }
        },
        [
          _c("el-table-column", {
            attrs: { label: "调拨编号", prop: "allocationNo" }
          }),
          _c("el-table-column", {
            attrs: { label: "便利店名称", prop: "outSellerId" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        "调出：" +
                          _vm._s(_vm._f("getSellerName")(scope.row.outSellerId))
                      )
                    ]),
                    _c("div", [
                      _vm._v(
                        "接收：" +
                          _vm._s(_vm._f("getSellerName")(scope.row.inSellerId))
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "调拨种类", prop: "outCategoryNum" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _vm._v("调出：" + _vm._s(scope.row.outCategoryNum))
                    ]),
                    _c("div", [
                      _vm._v("接收：" + _vm._s(scope.row.inCategoryNum))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "调拨数量", prop: "outGoodsNum" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _vm._v("调出：" + _vm._s(scope.row.outGoodsNum))
                    ]),
                    _c("div", [_vm._v("接收：" + _vm._s(scope.row.inGoodsNum))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "调拨金额", prop: "outGoodsAmount" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _vm._v("调出：" + _vm._s(scope.row.outGoodsAmount))
                    ]),
                    _c("div", [
                      _vm._v("接收：" + _vm._s(scope.row.inGoodsAmount))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "数量差", prop: "differenceNum" }
          }),
          _c("el-table-column", {
            attrs: { label: "金额差", prop: "differenceAmount" }
          }),
          _c("el-table-column", {
            attrs: { label: "时间", prop: "auditAt", width: "200px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        "调出：" +
                          _vm._s(
                            _vm._f("formatDateTime")(scope.row.allocationAt)
                          )
                      )
                    ]),
                    _c("div", [
                      _vm._v(
                        "接收：" +
                          _vm._s(_vm._f("formatDateTime")(scope.row.acceptAt))
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm.userInfo.sellerId > 0
            ? _c("el-table-column", {
                attrs: { label: "操作类型", width: "80px" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          scope.row.outSellerId == _vm.userInfo.sellerId
                            ? _c(
                                "el-tag",
                                { attrs: { type: "info", effect: "plain" } },
                                [_vm._v("调出")]
                              )
                            : _c(
                                "el-tag",
                                { attrs: { type: "success", effect: "plain" } },
                                [_vm._v("调入")]
                              )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3056870513
                )
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { label: "状态", prop: "allocationStatus", width: "100px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.allocationStatus == 1
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", effect: "plain" } },
                          [_vm._v("未提交")]
                        )
                      : _vm._e(),
                    scope.row.allocationStatus == 2
                      ? _c(
                          "el-tag",
                          { attrs: { type: "warning", effect: "plain" } },
                          [_vm._v("待接收")]
                        )
                      : _vm._e(),
                    scope.row.allocationStatus == 3
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", effect: "plain" } },
                          [_vm._v("已接收")]
                        )
                      : _vm._e(),
                    scope.row.allocationStatus == 4
                      ? _c(
                          "el-tag",
                          { attrs: { type: "info", effect: "plain" } },
                          [_vm._v("拒绝接收")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作区", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "table-button",
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onView(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    ),
                    (scope.row.allocationStatus == 2 &&
                      _vm.userInfo.sellerId == 0) ||
                    (scope.row.allocationStatus == 2 &&
                      _vm.userInfo.sellerId > 0 &&
                      scope.row.inSellerId == _vm.userInfo.sellerId)
                      ? _c(
                          "el-button",
                          {
                            staticClass: "table-button",
                            attrs: { size: "small", type: "warning" },
                            on: {
                              click: function($event) {
                                return _vm.onAccept(scope.row)
                              }
                            }
                          },
                          [_vm._v("接收")]
                        )
                      : _vm._e(),
                    scope.row.allocationStatus == 1
                      ? _c(
                          "el-dropdown",
                          { attrs: { trigger: "click" } },
                          [
                            _c("el-button", [
                              _vm._v("更多"),
                              _c("i", {
                                staticClass: "el-icon-arrow-down el-icon--right"
                              })
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.onSubmitAudit(scope.row)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { icon: "el-icon-check" } },
                                      [_vm._v("提审")]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.onUpdate(scope.row)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { icon: "el-icon-edit" } },
                                      [_vm._v("编辑")]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function($event) {
                                        return _vm.onDelete(scope.row)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { icon: "el-icon-delete" } },
                                      [_vm._v("删除")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.type == "view"
                ? "查看明细"
                : _vm.type == "submit"
                ? "提交操作"
                : _vm.type == "accept"
                ? "接收操作"
                : _vm.type == "update" || _vm.type == "add"
                ? "调拨操作（注意：【调拨金额】按最新成本单价计算）"
                : "",
            visible: _vm.dialogVisible,
            "custom-class":
              "bairun-dialog bairun-dialog-large allocation-dialog",
            "before-close": _vm.closeDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          ["add", "update"].includes(_vm.type)
            ? _c(
                "el-form",
                {
                  ref: "addForm",
                  staticStyle: { "margin-bottom": "15px" },
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.addRules,
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.isMobile ? 24 : 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "调出店铺", prop: "outSellerId" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    disabled: _vm.type == "update",
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "选择调出商店"
                                  },
                                  on: { change: _vm.onSellerSel },
                                  model: {
                                    value: _vm.formData.outSellerId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "outSellerId", $$v)
                                    },
                                    expression: "formData.outSellerId"
                                  }
                                },
                                _vm._l(_vm.allStations, function(item) {
                                  return _c("el-option", {
                                    key: item.ID,
                                    attrs: {
                                      label: item.stationName,
                                      value: item.ID
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.isMobile ? 24 : 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "接收店铺", prop: "inSellerId" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "bairun-required",
                                  attrs: {
                                    disabled: _vm.type == "update",
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "选择接收商店"
                                  },
                                  on: { change: _vm.onSellerSel },
                                  model: {
                                    value: _vm.formData.inSellerId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "inSellerId", $$v)
                                    },
                                    expression: "formData.inSellerId"
                                  }
                                },
                                _vm._l(_vm.sellerAllOptions, function(item) {
                                  return _c("el-option", {
                                    key: item.sellerId,
                                    attrs: {
                                      label: item.sellerName,
                                      value: item.sellerId
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.isMobile ? 24 : 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c(
                                "el-select",
                                {
                                  ref: "goodsSearchSelect",
                                  staticClass: "bairun-select-large",
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                    placeholder: "扫商品条形码或输入商品名搜索",
                                    "remote-method": _vm.goodsSearch,
                                    loading: _vm.goodsLoading,
                                    disabled:
                                      _vm.formData.outSellerId == "" ||
                                      _vm.formData.inSellerId == "" ||
                                      _vm.formData.outSellerId ==
                                        _vm.formData.inSellerId
                                  },
                                  on: { change: _vm.onGoodsSel },
                                  model: {
                                    value: _vm.spuNo,
                                    callback: function($$v) {
                                      _vm.spuNo = $$v
                                    },
                                    expression: "spuNo"
                                  }
                                },
                                _vm._l(_vm.goodsOptions, function(item) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: item.spuNo,
                                      attrs: {
                                        label: item.goodsName,
                                        value: item.spuNo
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("商品名称："),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-weight": "bold",
                                              color: "red"
                                            }
                                          },
                                          [_vm._v(_vm._s(item.goodsName))]
                                        )
                                      ]),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "margin-left": "15px" }
                                        },
                                        [
                                          _vm._v("规格："),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "bold",
                                                color: "red"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(item.goodsSpecification)
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "margin-left": "15px" }
                                        },
                                        [
                                          _vm._v("单位："),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "bold",
                                                color: "red"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.goodsUnit))]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "margin-left": "15px" }
                                        },
                                        [
                                          _vm._v("类目："),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "bold",
                                                color: "red"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.categoryName))]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "margin-left": "15px" }
                                        },
                                        [
                                          _vm._v("库存："),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "bold",
                                                color: "red"
                                              }
                                            },
                                            [_vm._v(_vm._s(item.goodsStock))]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.type == "view"
            ? _c(
                "el-form",
                {
                  ref: "viewForm",
                  staticStyle: { "margin-bottom": "15px" },
                  attrs: { model: _vm.formData, "label-position": "right" }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.isMobile ? 24 : 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "调出店铺：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.formData.outSellerName))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.isMobile ? 24 : 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "接收店铺：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.formData.inSellerName))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.isMobile ? 24 : 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "调出说明：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.formData.allocationRemark))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.isMobile ? 24 : 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "状态：" } },
                            [
                              _vm.formData.allocationStatus == 1
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { type: "info", effect: "plain" }
                                    },
                                    [_vm._v("未提交")]
                                  )
                                : _vm._e(),
                              _vm.formData.allocationStatus == 2
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: "warning",
                                        effect: "plain"
                                      }
                                    },
                                    [_vm._v("待接收")]
                                  )
                                : _vm._e(),
                              _vm.formData.allocationStatus == 3
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: "success",
                                        effect: "plain"
                                      }
                                    },
                                    [_vm._v("已接收")]
                                  )
                                : _vm._e(),
                              _vm.formData.allocationStatus == 4
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { type: "error", effect: "plain" }
                                    },
                                    [_vm._v("拒绝接收")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.type == "submit"
            ? _c(
                "el-form",
                {
                  ref: "submitForm",
                  staticStyle: { "margin-bottom": "15px" },
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.submitRules,
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.isMobile ? 24 : 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "调出店铺：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.formData.outSellerName))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.isMobile ? 24 : 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "接收店铺：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.formData.inSellerName))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.isMobile ? 24 : 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "bairun-required",
                              attrs: {
                                label: "调出说明：",
                                prop: "allocationRemark"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { height: "60px" },
                                attrs: {
                                  type: "textarea",
                                  clearable: "",
                                  placeholder: "调出说明"
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.inputChange($event)
                                  }
                                },
                                model: {
                                  value: _vm.formData.allocationRemark,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "allocationRemark",
                                      $$v
                                    )
                                  },
                                  expression: "formData.allocationRemark"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.type == "accept"
            ? _c(
                "el-form",
                {
                  ref: "acceptForm",
                  staticStyle: { "margin-bottom": "15px" },
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.acceptRules,
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.isMobile ? 24 : 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "调出店铺：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.formData.outSellerName))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.isMobile ? 24 : 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "接收店铺：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.formData.inSellerName))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.isMobile ? 24 : 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "调出说明：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.formData.allocationRemark))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.isMobile ? 24 : 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "bairun-required",
                              attrs: {
                                label: "接收说明：",
                                prop: "acceptRemark"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { height: "60px" },
                                attrs: {
                                  type: "textarea",
                                  placeholder:
                                    "接收说明，如有差额，请说明差额原因",
                                  clearable: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.inputChange($event)
                                  }
                                },
                                model: {
                                  value: _vm.formData.acceptRemark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "acceptRemark", $$v)
                                  },
                                  expression: "formData.acceptRemark"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.isMobile ? 24 : 8 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "bairun-required",
                              attrs: {
                                label: "接收结果：",
                                prop: "allocationStatus"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: "接收结果"
                                  },
                                  model: {
                                    value: _vm.formData.allocationStatus,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "allocationStatus",
                                        $$v
                                      )
                                    },
                                    expression: "formData.allocationStatus"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    key: "3",
                                    attrs: { label: "接收", value: "3" }
                                  }),
                                  _c("el-option", {
                                    key: "4",
                                    attrs: { label: "拒绝", value: "4" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.goodsAllocationDetailTableData,
                    border: "",
                    stripe: "",
                    "tooltip-effect": "dark"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "商品名称", prop: "goodsName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "最新成本价", prop: "goodsLatestCost" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "调拨数量", prop: "outGoodsNum" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            ["add", "update"].includes(_vm.type)
                              ? _c("el-input-number", {
                                  staticClass: "bairun-input-fill",
                                  staticStyle: { height: "47px" },
                                  attrs: {
                                    min: 0,
                                    max: scope.row.goodsStock,
                                    placeholder: "调拨数量",
                                    "controls-position": "right",
                                    clearable: ""
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.onInputOutNum(scope.row)
                                    }
                                  },
                                  model: {
                                    value: scope.row.outGoodsNum,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "outGoodsNum", $$v)
                                    },
                                    expression: "scope.row.outGoodsNum"
                                  }
                                })
                              : _c("div", [
                                  _vm._v(_vm._s(scope.row.outGoodsNum))
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "调拨金额", prop: "outGoodsAmount" }
                  }),
                  ["accept"].includes(_vm.type)
                    ? _c("el-table-column", {
                        attrs: { label: "条形码", prop: "goodsNo" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  ["accept"].includes(_vm.type)
                                    ? _c("el-input", {
                                        staticClass:
                                          "bairun-input-fill bairun-required",
                                        staticStyle: { height: "47px" },
                                        attrs: {
                                          placeholder: "请扫条码",
                                          "controls-position": "right",
                                          clearable: ""
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange()
                                          }
                                        },
                                        model: {
                                          value: scope.row.goodsNo,
                                          callback: function($$v) {
                                            _vm.$set(scope.row, "goodsNo", $$v)
                                          },
                                          expression: "scope.row.goodsNo"
                                        }
                                      })
                                    : _c("div", [
                                        _vm._v(_vm._s(scope.row.goodsNo))
                                      ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          871086587
                        )
                      })
                    : _vm._e(),
                  ["accept", "view"].includes(_vm.type)
                    ? _c("el-table-column", {
                        attrs: {
                          label: "销售单价",
                          prop: "goodsPrice",
                          align: "center"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  ["view"].includes(_vm.type)
                                    ? _c("div", [
                                        _vm._v(_vm._s(scope.row.goodsPrice))
                                      ])
                                    : scope.row.exitGoodsPrice
                                    ? _c("div", [
                                        _vm._v(_vm._s(scope.row.goodsPrice))
                                      ])
                                    : _c("el-input-number", {
                                        staticClass:
                                          "bairun-input-fill bairun-required",
                                        staticStyle: { height: "47px" },
                                        attrs: {
                                          min: 0,
                                          placeholder: "请输入",
                                          "controls-position": "right",
                                          clearable: ""
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.inputChange()
                                          }
                                        },
                                        model: {
                                          value: scope.row.goodsPrice,
                                          callback: function($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "goodsPrice",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.goodsPrice"
                                        }
                                      })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4106257700
                        )
                      })
                    : _vm._e(),
                  ["accept", "view"].includes(_vm.type)
                    ? _c("el-table-column", {
                        attrs: { label: "接收数量", prop: "inGoodsNum" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  ["accept"].includes(_vm.type)
                                    ? _c("el-input-number", {
                                        staticClass:
                                          "bairun-input-fill bairun-required",
                                        staticStyle: { height: "47px" },
                                        attrs: {
                                          min: 0,
                                          max: scope.row.outGoodsNum,
                                          placeholder: "接收数量",
                                          "controls-position": "right",
                                          clearable: ""
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.onInputAcceptNum(
                                              scope.row
                                            )
                                          }
                                        },
                                        model: {
                                          value: scope.row.inGoodsNum,
                                          callback: function($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "inGoodsNum",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.inGoodsNum"
                                        }
                                      })
                                    : _c("div", [
                                        _vm._v(_vm._s(scope.row.inGoodsNum))
                                      ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1103073500
                        )
                      })
                    : _vm._e(),
                  ["accept", "view"].includes(_vm.type)
                    ? _c("el-table-column", {
                        attrs: { label: "接收金额", prop: "inGoodsAmount" }
                      })
                    : _vm._e(),
                  ["accept", "view"].includes(_vm.type)
                    ? _c("el-table-column", {
                        attrs: { label: "数量差", prop: "differenceNum" }
                      })
                    : _vm._e(),
                  ["accept", "view"].includes(_vm.type)
                    ? _c("el-table-column", {
                        attrs: { label: "金额差", prop: "differenceAmount" }
                      })
                    : _vm._e(),
                  ["add", "update"].includes(_vm.type)
                    ? _c("el-table-column", {
                        attrs: { label: "操作", width: "60px" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c("el-button", {
                                    attrs: {
                                      icon: "el-icon-close",
                                      size: "mini",
                                      circle: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onDelGoods(scope.row)
                                      }
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2375848769
                        )
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onDialogSubmit }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }